import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import {
  SEARCH_MODULE_NAMESPACE,
  SEARCH_AUTOCOMPLETE,
  SEARCH_REQUEST_BYKEYS_FORCE
} from '../../../../store/search';
import {namespace} from 'vuex-class';
import {SearchEntities} from '../../../../common/enums';
import {TICKET_MODULE_NAMESPACE} from '../../../../store/ticket';
import {ITicket} from '../../../../models/ticket';
import {
  DOCUMENT_GET_DOCUMENTS_ATTACHMENTS,
  DOCUMENT_MODULE_NAMESPACE,
  DOCUMENT_SET_DOCUMENT_PARAMETER
} from "../../../../store/document";
import {IDocumentListingViewmodel, IDocumentParamter} from "../../../../models/documents";

const SearchStore = namespace(SEARCH_MODULE_NAMESPACE);
const TicketStore = namespace(TICKET_MODULE_NAMESPACE);
const DocumentStore = namespace(DOCUMENT_MODULE_NAMESPACE)

@Component({
  components: {
    'ticket-mandate-selector': async () => import('../ticket-mandate-selector/TicketMandateSelector.vue'),
    'mandate-quote-selector': async () => import('../ticket-mandate-or-quote-selector/TicketMandateOrQuoteSelector.vue')
  }
})
class TicketChatModalMandateSpeaker extends Vue {

  @Prop({default: {}, type: [Object]})
  value: { attachments: any[], fk_actor_entity: number[], ext: string }
  @Prop({type: [String]})
  textKey: string;

  dtContractors: number[];
  dtRules: {
    mandateContractorRules?: any;
  }
  dtAttachments: any[];
  dtGEDSearch: string;
  dtSelectedGED: any[];
  dtTotalGED: number;

  /**
   *
   */
  constructor() {
    super();
    this.dtContractors = [];
    this.dtRules = {}
    this.dtAttachments = [];
    this.dtGEDSearch = ''
    this.dtSelectedGED = []
    this.dtTotalGED = 0
  }

  @TicketStore.Getter attachments: any[];
  @TicketStore.Getter currentTicket: ITicket;
  @SearchStore.Action(SEARCH_REQUEST_BYKEYS_FORCE)
  storeGetIndependentContractors: (payload: { keys: string[], force?: boolean }) => Promise<any[]>;
  @SearchStore.Action(SEARCH_AUTOCOMPLETE)
  storeGetResources: (payload: { entity: SearchEntities[], query?: string }) => Promise<any[]>;
  @SearchStore.Getter independent_contractors: any[];

  @DocumentStore.Getter documents: IDocumentListingViewmodel[]
  @DocumentStore.Action(DOCUMENT_GET_DOCUMENTS_ATTACHMENTS)
  storeGetDocumentAttachments: () => Promise<any>
  @DocumentStore.Mutation(DOCUMENT_SET_DOCUMENT_PARAMETER)
  storeSetDocumentParameter: (payload: IDocumentParamter) => void

  get resources() {
    return (this.independent_contractors || []).map(x => {
      return {lastname: x.lastname, firstname: x.firstname, id: x.id, text: `${x.firstname} ${x.lastname}`}
    })
  }

  get hasDocModule()
  {
    const modules = this.$store.state.user.userInfo.modules
    return modules.includes('document_management')
  }

  get lblSetting() {
    return {
      ...require('../../../../locales/validation-messages').default,
      ...require('../../../../locales/ticket').default,
      ...require('@/locales/generic-labels').default
    }
  }

  get textConfigs() {
    return require("@/assets/json-resources/text-field-configs.json")
  }

  get fkActorAntity(): number[] {
    return this.value.fk_actor_entity;
  }

  set fkActorAntity(value: number[]) {
    this.$emit('input', Object.assign({}, this.value, {fk_actor_entity: value}))
  }

  get vAttachments(): any[] {
    return this.value.attachments;
  }

  set vAttachments(value: any[]) {
    this.$emit('input', Object.assign({}, this.value, {attachments: value}))
  }

  get description(): string {
    return this.value[this.textKey];
  }

  set description(value: string) {
    this.$emit('input', Object.assign({}, this.value, {[this.textKey]: value}))
  }

  get coAttachments(): any[] {
    this.dtAttachments = JSON.parse(JSON.stringify(this.attachments));
    return this.dtAttachments;
  }

  set coAttachments(value: any[]) {
    this.dtAttachments = value;
  }

  get coDocuments(): any[] {
    return this.dtSelectedGED.concat(this.documents.filter(x => this.dtSelectedGED.findIndex(y => y.id === x.id) === -1))
  }

  get entities(): SearchEntities[] {
    if (this.textKey === 'quote_request_text')
      return [SearchEntities.IndependentContractor]
    else
      return [SearchEntities.Contractor, SearchEntities.CareTaker]

  }

  get secondlabelTranslation(): string {
    if (this.textKey === 'quote_request_text') {
      return this.lblSetting.ticketChatActionsAskQuoteLabel
    }
    return this.lblSetting.ticketMandateOrderService
  }

  mounted() {
    if (this.currentTicket.description) {
      this.description = this.currentTicket.description
    }
    this.dtRules.mandateContractorRules = [(v) => v.length > 0 || this.$t(this.lblSetting.contractorRequired)]
    this.loadGEDDocuments()
  }

  handleChooseAttachment(attachment) {
    attachment.checked = !attachment.checked
    if (!attachment.action_type) {
      if (attachment.checked) {
        this.dtSelectedGED.push(attachment)
      } else {
        let idx = this.dtSelectedGED.findIndex(x => x.id === attachment.id)
        if (idx > -1) {
          this.dtSelectedGED.splice(idx, 1);
        }
      }
    }
    this.vAttachments = this.coAttachments.filter(a => a.checked === true).map(a => {
      return {url: a.attachment.media.link, mediaId: a.attachment.media.id}
    }).concat(this.dtSelectedGED.map(a => ({url: (a as any).link, mediaId: a.id})))
  }

  loadGEDDocuments () {
    this.storeSetDocumentParameter(
      {
        apartment: [],
        creator: [],
        $limit: 12,
        detail: 'true',
        block: []
      }
    )
    this.storeGetDocumentAttachments()
      .then(res => {
        this.dtTotalGED = res.total
      })
  }

  _clearTimeout: any
  searchGEDByKey (value) {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      this.storeSetDocumentParameter({key: value || ''})
      this.storeGetDocumentAttachments()
        .then(res => {})
    }, 300)
  }
}

export default TicketChatModalMandateSpeaker;



// WEBPACK FOOTER //
// ./src/containers/ticket/components/ticket-chat-modal-mandate-speaker/index.ts